import React from 'react';
import { MdOpenInNew } from 'react-icons/md';

type McpGuide = {
  id: string;
  label: string;
  url: string;
};

const MCP_GUIDES: McpGuide[] = [
  {
    id: 'claude',
    label: 'Claudeをご利用の方',
    url: 'https://help.agenthub.jp/Claude-MCP-34b58b343fa48136b1a3cfde6b475f0f',
  },
  {
    id: 'chatgpt',
    label: 'ChatGPTをご利用の方',
    url: 'https://help.agenthub.jp/ChatGPT-34b58b343fa4813ba735c1409e69e771',
  },
];

const McpSettingsSection: React.FC = () => {
  return (
    <div className="rounded-sm bg-white px-x3l py-xl shadow-layer1">
      <div className="flex flex-col gap-lg">
        <div className="flex flex-col gap-xs">
          <h2 className="text-heading-xs">MCPによる連携</h2>
          <p className="text-body-sm">ご利用のAIサービスに応じて、連携手順をご確認ください。</p>
        </div>
        <div className="grid grid-cols-2 gap-md">
          {MCP_GUIDES.map((guide) => (
            <a
              key={guide.id}
              href={guide.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between rounded border border-solid border-border p-md text-inherit no-underline hover:border-primary hover:shadow-layer1"
            >
              <span className="text-heading-xxs text-primary">{guide.label}</span>
              <MdOpenInNew size={18} className="text-sub" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default McpSettingsSection;
